import { render, staticRenderFns } from "./MusicSelectionItem.vue?vue&type=template&id=f19d70b2&scoped=true&"
import script from "./MusicSelectionItem.vue?vue&type=script&lang=js&"
export * from "./MusicSelectionItem.vue?vue&type=script&lang=js&"
import style0 from "./MusicSelectionItem.vue?vue&type=style&index=0&id=f19d70b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19d70b2",
  null
  
)

export default component.exports